import React, { PureComponent } from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import {
  BellFilled,
  NotificationOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  PoweroffOutlined,
  MessageOutlined,
  BellOutlined,
  PhoneOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
  MailOutlined,
  CaretRightOutlined,
  UserOutlined,
  RobotFilled
} from '@ant-design/icons';

import {
  Layout,
  Row,
  Col,
  Popover,
  Menu,
  Modal,
  Upload,
  Badge,
  notification,
  List,
  Space,
  Typography,
  Button,
  PageHeader,
  FloatButton
} from 'antd';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import logo from 'src/static/logo-white.svg';
import MenuIcon from 'src/static/menu-icon.svg';
import MenuOpenIcon from 'src/static/menu-open-icon.svg';
import logoWhite from 'src/static/logo-white.svg';
import { Cookies } from 'react-cookie';
import { saveAccountInfo } from 'src/redux/actions/user';
import {
  getSidebarCollapsed,
  getUser,
  getNotifications
} from 'src/redux/selectors';

import { ButtonSquare } from 'src/components/elements/Button';
import { push } from 'connected-react-router';
import { collapseSidebar } from 'src/redux/actions/status';
import { withIsMobile } from 'src/utils/responsive';
import Resizer from 'react-image-file-resizer';
import Notify from 'src/components/meta/Notification';
import { setStockDetailsId } from 'src/redux/actions/stock';
import {
  findNotifications,
  removeNotification
} from 'src/redux/actions/notifications';
import LogoSmall from '../../static/logo-small.png';
const { Title } = Typography;

const signOut = s => {
  // if (window.cordova) {
  //   window.FirebasePlugin.getToken(
  //     token => {
  //       window.pubnub.push.deleteDevice(
  //         {
  //           device: token,
  //           pushGateway: 'gcm' // apns, gcm, mpns
  //         },
  //         function (status) {
  //           if (status.error) {
  //             console.log('operation failed w/ error:', status);
  //           }
  //         }
  //       );
  //     },
  //     error => {
  //       console.error(error);
  //     }
  //   );
  // }

  const cookies = new Cookies();
  cookies.remove('token');
  cookies.remove('basic');
  localStorage.clear();
  window.location.reload();
};

if (window.innerWidth <= 440 || window.innerHeight <= 440) {
  window.isPhone = true;
} else {
  window.isPhone = false;
}
export class ResHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }

  signOut = () => {
    if (window.cordova) {
      window.FirebasePlugin.getToken(
        token => {
          window.pubnub.push.deleteDevice(
            {
              device: token,
              pushGateway: 'gcm' // apns, gcm, mpns
            },
            function (status) {
              if (status.error) {
                console.log('operation failed w/ error:', status);
              }
            }
          );
        },
        error => {
          console.error(error);
        }
      );
    }

    const cookies = new Cookies();
    cookies.remove('token');
    cookies.remove('basic');
    localStorage.clear();
    window.location.reload();
  };

  exit = false;
  handleBack = () => {
    this.props.history.goBack();
  };

  render() {
    return (

      <Row style={{
        zIndex: 100,
        backgroundColor: this.props.isMobile ? '#111111e0' : undefined,
        position: 'fixed',
        // On mobile the sidebar overlays rather than displacing the page, so
        // the header spans the full width and the hamburger below toggles it.
        width: this.props.isMobile
          ? '100%'
          : this.props.collapsed
            ? 'calc(100% - 155px)'
            : 'calc(100% - 355px)',
        marginLeft: this.props.isMobile
          ? 0
          : this.props.collapsed
            ? '90px'
            : '310px',
        padding: 0,
        height: this.props.isMobile ? 56 : undefined,
        alignItems: this.props.isMobile ? 'center' : undefined,
        borderRadius: this.props.isMobile ? '0 0 14px 14px' : undefined,
        boxShadow: this.props.isMobile
          ? '0 6px 18px rgba(0, 0, 0, 0.2)'
          : undefined,
        border: this.props.isMobile
          ? 'none'
          : 'rgb(0 0 0 / 10%) 0px 6px 10px 0px'
      }}>
        {this.props.isMobile && (
          <Button
            type="text"
            aria-label="Toggle navigation"
            onClick={() => this.props.collapseSidebar()}
            icon={
              this.props.collapsed ? (
                <MenuUnfoldOutlined style={{ fontSize: 22 }} />
              ) : (
                <MenuFoldOutlined style={{ fontSize: 22 }} />
              )
            }
            style={{
              position: 'absolute',
              top: 8,
              left: 10,
              zIndex: 101,
              height: 40,
              width: 40,
              color: 'white',
              backgroundColor: 'rgba(128, 206, 144, 0.16)',
              border: '1px solid rgba(128, 206, 144, 0.35)',
              borderRadius: 12
            }}
          />
        )}
        {/* {this.props.isMobile && (
          <img
            src={logo}
            alt="Sprout Management"
            style={{
              position: 'absolute',
              top: 12,
              left: '50%',
              width: 112,
              height: 29,
              objectFit: 'contain',
              transform: 'translateX(-50%)'
            }}
          />
        )} */}
        <Col
          span={24}
          style={{
            margin: 'auto',
            height: this.props.isMobile ? 56 : undefined,
            paddingRight: this.props.isMobile ? 10 : 0,
            borderLeft: '0px solid #E5E5E5',
            display: this.props.isMobile ? 'flex' : undefined,
            alignItems: this.props.isMobile ? 'center' : undefined,
            justifyContent: this.props.isMobile ? 'flex-end' : undefined
          }}
        >
          {/* <FloatButton
            onClick={this.signOut}
            icon={<BellFilled style={{ color: "#80CE90", }} />}
            shape="circle"
            badge={{
              count: 1,
            }}
            style={{
              top: 10,
              right: 70
            }}
          /> */}

          <Popover
            placement="bottomRight"
            content={
              <div
                style={{
                  width: this.props.isMobile ? 280 : undefined,
                  maxWidth: this.props.isMobile
                    ? 'calc(100vw - 3em)'
                    : undefined
                }}
              >
                <Row type="flex" justify="space-between" align="middle">
                  <Col span={6}>
                    {this.props.user.image ? (
                      <div
                        onClick={e =>
                          this.setState({
                            imageVisible: true,
                            image: this.props.user.image
                          })
                        }
                        style={{
                          border: '1px solid #80CE903b',
                          cursor: 'pointer',
                          height: 40,
                          width: 40,
                          margin: 'auto',
                          borderRadius: '50%',
                          display: 'flex',
                          overflow: 'hidden'
                        }}
                      >
                        <img
                          style={{ margin: 'auto', width: 40 }}
                          alt="Profile"
                          src={this.props.user.image}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={e => this.setState({ imageVisible: true })}
                        style={{
                          cursor: 'pointer',
                          height: 40,
                          width: 40,
                          margin: 'auto',
                          borderRadius: '50%',
                          backgroundColor: '#80CE90',
                          display: 'flex'
                        }}
                      >
                        <span
                          style={{
                            margin: 'auto',
                            lineHeight: '40px',
                            fontSize: 20,
                            color: 'white'
                          }}
                        >
                          {this.props.user.name.substr(0, 1)}
                        </span>
                      </div>
                    )}
                  </Col>
                  <Col span={17}>
                    <div
                      style={{
                        margin: '0px 0px 8px 0px',
                        width: this.props.isMobile ? 'auto' : 250,
                        overflowWrap: 'anywhere'
                      }}
                    >
                      <span style={{ fontSize: 13 }}>
                        <strong>Username : </strong> {this.props.user.username}
                      </span>
                    </div>

                    {/*<ButtonSquare
                      style={{ height: 35 }}
                      onClick={(e) => {
                        if (this.props.user.type === "manager") {
                          this.props.push("/manager/account");
                        } else if (this.props.user.type === "user") {
                          this.props.push("/user/account");
                        } else if (this.props.user.type === "admin") {
                          this.props.push("/admin/account");
                        }
                      }}
                      type='primary'
                    >
                      My Settings
                    </ButtonSquare>*/}
                  </Col>
                </Row>
                <Row
                  type="flex"
                  justify="space-between"
                  align="middle"
                  style={{ marginTop: 20 }}
                >
                  <Menu
                    style={{ background: 'none' }}
                    theme="light"
                    mode="inline"
                  >
                    <Menu.Item onClick={this.signOut} key="signout">
                      <PoweroffOutlined />
                      <span>Sign Out</span>
                    </Menu.Item>
                  </Menu>
                </Row>
              </div>
            }
            trigger="click"
          // visible={this.state.visible}
          >
            {this.props.user.image ? (
              <div
                onClick={e => this.setState({ visible: !this.state.visible })}
                style={{
                  border: '1px solid #80CE903b',
                  cursor: 'pointer',
                  height: this.props.isMobile ? 38 : 40,
                  width: this.props.isMobile ? 38 : 40,
                  margin: this.props.isMobile ? 0 : 'auto',
                  borderRadius: '50%',
                  display: 'flex',
                  overflow: 'hidden',
                  boxShadow: this.props.isMobile
                    ? '0 0 0 2px rgba(128, 206, 144, 0.2)'
                    : undefined
                }}
              >
                <img
                  style={{
                    margin: 'auto',
                    width: this.props.isMobile ? 38 : 40,
                    height: this.props.isMobile ? 38 : 40,
                    objectFit: 'cover'
                  }}
                  alt="Profile"
                  src={this.props.user.image}
                />
              </div>
            ) : (
              <div

              //style={{ display: "none" }}
              //onClick={(e) => {
              //  this.setState({ visible: !this.state.visible });
              //}}
              >

                {this.props.isMobile ? (
                  <Button
                    type="text"
                    aria-label="Open account menu"
                    icon={<RobotFilled style={{ color: '#80CE90' }} />}
                    style={{
                      width: 40,
                      height: 40,
                      padding: 0,
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 255, 255, 0.08)',
                      border: '1px solid rgba(128, 206, 144, 0.35)'
                    }}
                  />
                ) : (
                  <FloatButton
                    icon={<RobotFilled style={{ color: '#80CE90' }} />}
                    shape="circle"
                    style={{ top: 10 }}
                  />
                )}
              </div>
            )}
          </Popover>{' '}
        </Col>{' '}
      </Row>

    );
  }
}

const mapStateToProps = state => ({
  collapsed: getSidebarCollapsed(state),
  notifications: getNotifications(state) || [],
  user: getUser(state) || {}
});

const mapDispatchToProps = {
  collapseSidebar,
  push,
  saveAccountInfo,
  setStockDetailsId,
  findNotifications,
  removeNotification
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withIsMobile(ResHeader))
);
